import React, { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { useZxing } from "react-zxing";
import { barcodeCheck } from "../../actions/codeActions";

import "./QRScanner.scss";

const QRScanner = ({ history }) => {
    const dispatch = useDispatch();

    const [code, setCode] = useState(undefined);
    const [lastScanned, setLastScanned] = useState(null);
    const [isError, setError] = useState(false);
    const [notFound, setNotFound] = useState(false);
    const scanCooldownRef = useRef(false);

    const { ref } = useZxing({
        onDecodeResult(result) {
            const scanned = result.getText();
            console.log("Scanned:", scanned);

            if (!scanCooldownRef.current && scanned !== lastScanned) {
                scanCooldownRef.current = true;
                setLastScanned(scanned);
                setCode(scanned);

                setTimeout(() => {
                    scanCooldownRef.current = false;
                }, 2000);
            }
        },
        onError(err) {
            console.warn("Scan error:", err);
            setError(true);
        },
    });

    useEffect(() => {
        if (!code) return;

        dispatch(barcodeCheck(code)).then((res) => {
            if (res && res.payload && res.payload.status === 200) {
                setError(false);
                history.push(`/main/shop/product/${res.payload.data.id}`);
            } else {
                setError(true);
                setNotFound(code);

                setTimeout(() => {
                    setNotFound(false);
                    setError(false);
                }, 4000);
            }
        });
    }, [code, dispatch, history]);

    return (
        <div className="camera-page">
            <video
                ref={ref}
                className="camera-video"
                autoPlay
                muted
                playsInline
            />
            {isError && (
                <p className="camera-error">
                    {notFound
                        ? <>Товар с баркодом <b>{notFound}</b> не найден в базе</>
                        : "Баркод не распознан"}
                </p>
            )}
        </div>
    );
};

export default QRScanner;
